import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import {
  BODY_PATTERN_FIELDS,
  BODY_PATTERN_VALUES,
  EMPTY_BODY_PATTERN_TICKS,
  ticksFromRow,
  upsertBodyPatternTicks,
} from '../lib/bodyPatternTicks';
import './BodyPatternTicks.css';

const BodyPatternTicks = ({ videoId, user }) => {
  const [ticks, setTicks] = useState(EMPTY_BODY_PATTERN_TICKS);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (!videoId || !user?.id) {
        setLoading(false);
        return;
      }
      setLoading(true);
      setError('');
      const { data, error: loadError } = await supabase
        .from('body_pattern_ticks')
        .select('*')
        .eq('video_id', videoId)
        .eq('user_id', user.id)
        .maybeSingle();
      if (cancelled) return;
      if (loadError) {
        setError(loadError.message || 'Could not load ticks.');
      } else {
        setTicks(ticksFromRow(data));
      }
      setLoading(false);
    };
    load();
    return () => { cancelled = true; };
  }, [videoId, user?.id]);

  const saveField = async (key, value) => {
    if (!videoId || !user?.id) return;
    const next = { ...ticks, [key]: value };
    setTicks(next);
    setStatus('Saving…');
    setError('');
    try {
      await upsertBodyPatternTicks(supabase, videoId, user.id, next);
      setStatus('Saved');
    } catch (err) {
      setStatus('');
      setError(err.message || 'Could not save ticks.');
    }
  };

  if (!user?.id || !videoId) return null;

  return (
    <div className="body-pattern-ticks">
      <h5>Body pattern ticks</h5>
      <p className="body-pattern-note">
        What you can see in this clip. This is not a lame/sound call and it does not change the score.
      </p>
      {loading ? (
        <p className="body-pattern-status">Loading ticks…</p>
      ) : (
        BODY_PATTERN_FIELDS.map((field) => (
          <div key={field.key} className="body-pattern-row">
            <div className="body-pattern-copy">
              <p className="body-pattern-label">{field.label}</p>
              <p className="body-pattern-hint">{field.hint}</p>
            </div>
            <div className="body-pattern-buttons">
              {BODY_PATTERN_VALUES.map((option) => (
                <button
                  key={option.value}
                  type="button"
                  className={`body-pattern-btn ${ticks[field.key] === option.value ? `selected ${option.value}` : ''}`}
                  onClick={() => saveField(field.key, option.value)}
                >
                  {option.label}
                </button>
              ))}
            </div>
          </div>
        ))
      )}
      {status && !error && <p className="body-pattern-status saved">{status}</p>}
      {error && <p className="body-pattern-status error">{error}</p>}
    </div>
  );
};

export default BodyPatternTicks;
